import React from 'react';
import data from './component/data';
import WaterWave from 'react-water-wave';
import Contact from './component/Contact';
import Slider from 'react-slick';
/*
import Navbar from './component/Navbar/Navbar';
import About from './component/About';
import Service from './component/Service';
import Portfolio from './component/Portfolio/Portfolio';
import Testimonial from './component/Testimonial/Testimonial';
import Clientslogo from './component/Clientslogo';
import Blog from './component/Blog/Blog';

import Skill from './component/Skill/Skill';
import Footer from './component/Footer';
*/

export const Home = () => (
  <div className="body_wrapper">
    <div className="home">
      <WaterWave
        height={"100%"}
        resolution={256}
        perturbance={0.01}
        className={`banner_area`}
        style={{ width: '100%', height: '100%', backgroundSize: "fill", backgroundPosition: "50% 30%" }}
        imageUrl={require("./image/back.jpg")}>
        {({ getRootProps }) => (
          <div className={`banner_content`}>
            <img style={{ width: "80%", maxWidth: "400px", marginBottom: "20px" }} src={require("./image/logo.png")} alt="" />
            <ul className="list_style social_icon">
              {
                data.socialLinks && data.socialLinks.map(item => {
                  return (
                    <li key={item.name}>
                      <a href={item.url}><i className={item.className}></i></a>
                    </li>
                  )
                }
                )
              }
            </ul>
          </div>
        )}
      </WaterWave >
      <Slider className="home_slider" autoplay autoplaySpeed={5000} speed={1000}>
        <div className="item">
          <div style={{ justifyContent: "center", display: "flex", alignItems: "baseline", textAlign: "center" }}>
            <img style={{ height: "18px", paddingRight: "15px" }} alt="language" src={require('./image/lang/de.png')} />
            <h4>WARTUNGSARBEITEN</h4>
          </div>
          <h5>Wir sind bald wieder für Sie da.</h5>
          <span>Gerne sind wir telefonisch oder per E-Mail für Sie erreichbar. Vielen Dank für Ihr Verständnis.</span>
        </div>
        <div className="item">
          <div style={{ justifyContent: "center", display: "flex", alignItems: "baseline", textAlign: "center" }}>
            <img style={{ height: "18px", paddingRight: "15px" }} alt="language" src={require('./image/lang/en.png')} />
            <h4>MAINTENANCE</h4>
          </div>
          <h5>We will be back soon.</h5>
          <span>We are happy to be reached by phone or email. Thank you for your understanding.</span>
        </div>
        <div className="item">
          <div style={{ justifyContent: "center", display: "flex", alignItems: "baseline", textAlign: "center" }}>
            <img style={{ height: "18px", paddingRight: "15px" }} alt="language" src={require('./image/lang/it.png')} />
            <h4>MANUTENZIONE</h4>
          </div>
          <h5>Torneremo presto.</h5>
          <span>Siamo felici di essere raggiunti per telefono o e-mail. Grazie per la vostra comprensione.</span>
        </div>
        <div className="item">
          <div style={{ justifyContent: "center", display: "flex", alignItems: "baseline", textAlign: "center" }}>
            <img style={{ height: "18px", paddingRight: "15px" }} alt="language" src={require('./image/lang/nl.png')} />
            <h4>ONDERHOUD</h4>
          </div>
          <h5>We zullen snel terugkomen.</h5>
          <span>Wij zijn graag telefonisch of per e-mail bereikbaar. Bedankt voor uw begrip.</span>
        </div>
        <div className="item">
          <div style={{ justifyContent: "center", display: "flex", alignItems: "baseline", textAlign: "center" }}>
            <img style={{ height: "18px", paddingRight: "15px" }} alt="language" src={require('./image/lang/si.png')} />
            <h4>VZDRŽEVALNA DELA</h4>
          </div>
          <h5>Kmalu se vrnemo.</h5>
          <span>Z veseljem smo dosegljivi po telefonu ali e-pošti. Hvala za razumevanje.</span>
        </div>
        <div className="item">
          <div style={{ justifyContent: "center", display: "flex", alignItems: "baseline", textAlign: "center" }}>
            <img style={{ height: "18px", paddingRight: "15px" }} alt="language" src={require('./image/lang/cz.png')} />
            <h4>RADOVI ODRŽAVANJA</h4>
          </div>
          <h5>Vratit ćemo se uskoro.</h5>
          <span>Drago nam je da nas kontaktirate telefonom ili e-poštom. Hvala na razumijevanju.</span>
        </div>
      </Slider>
    </div>
    <div className="row row">
      <Contact data={data} />
    </div>
  </div >
)